'use client';

import React from 'react';
import styled, { useTheme } from 'styled-components';
import { useLabels } from '@liftango/ui-tokens';

export interface SignalBarsProps {
  level: number;
  size?: number;
}

function signalLabel(level: number): string {
  if (level >= 3) return 'good';
  if (level >= 1) return 'weak';
  return 'lost';
}

const Wrapper = styled.span`
  display: inline-flex;
  align-items: flex-end;
  gap: 1.5px;
`;

const BAR_HEIGHTS = [3, 5.5, 8, 10.5];

const Bar = styled.span<{ $h: number; $active: boolean; $color: string }>`
  width: 2.5px;
  height: ${(p) => p.$h}px;
  background: ${(p) => (p.$active ? p.$color : p.theme.colors.neutral.line)};
  border-radius: 0.5px;
`;

export function SignalBars({ level, size }: SignalBarsProps) {
  const labels = useLabels();
  const theme = useTheme();
  const key = signalLabel(level);
  const label = labels.signal?.[key] ?? `Signal: ${key}`;
  const color = level >= 3 ? theme.colors.semantic.success.color : theme.colors.semantic.warn.color;

  return (
    <Wrapper role="img" aria-label={label} style={size ? { height: size } : undefined}>
      {BAR_HEIGHTS.map((h, i) => (
        <Bar key={i} data-bar $h={h} $active={i < level} $color={color} />
      ))}
    </Wrapper>
  );
}
